<template>
    <div>
        <button v-cloak v-show="following && manage" @click.stop="showListingsModal" :class="followButtonClass" type="button" class="focus:outline-none">
            <spinner :loading="loading" class="fa-lg" />
            <span v-cloak v-show="!loading">
                <!-- <fa-icon :icon="['fas', 'bell']" class="mr-1" /> -->
                <i :class="iconClass" class="fad fa-bell fa-lg mr-1"></i>
                Manage Alerts
            </span>
        </button>

        <button v-cloak v-show="following && !manage" @click.stop="onClickUnfollow" :class="followButtonClass" type="button" class="focus:outline-none" v-tooltip="tooltipOptions">
            <spinner :loading="loading" class="fa-lg" />
            <span v-cloak v-show="!loading">
                <slot v-if="unsubscribeSlotPassed" name="unsubscribe"></slot>
                <span v-else>
                    <!-- <fa-icon :icon="['fas', 'bell-slash']" class="mr-1" /> -->
                    <i :class="iconClass" class="far fa-bell-slash fa-lg mr-1"></i>
                    {{ unsubscribeText || 'Unfollow' }}
                </span>
            </span>
        </button>

        <button v-cloak v-show="!following" @click.stop="onClickFollow" :class="unfollowButtonClass" type="button" class="focus:outline-none" v-tooltip="tooltipOptions">
            <spinner :loading="loading" class="fa-lg" />
            <span v-cloak v-show="!loading">
                <slot v-if="subscribeSlotPassed" name="subscribe"></slot>
                <span v-else>
                    <!-- <fa-icon :icon="['fas', 'bell']" class="mr-1" /> -->
                    <i :class="iconClass" class="far fa-bell-plus fa-lg mr-1"></i>
                    {{ subscribeText || 'Follow' }}
                </span>
            </span>
        </button>

        <portal v-if="showAuthModal" to="modals">
            <auth-modal v-if="showAuthModal" @authed="onUserAuth" @close="onAuthModalClosed" />
        </portal>
        <!-- <portal v-if="showListingModal" to="modals" transition="fade-transition"> -->
        <portal v-if="showListingModal" to="modals">
            <product-listings-modal v-if="showListingModal" @close="onListingModalClosed" :product="product" />
        </portal>
    </div>
</template>

<script>
export default {
    props: [
        'product',
        'tooltip',
        'btn-class',
        'subscribe-text',
        'unsubscribe-text',
        'subscribe-tooltip',
        'unsubscribe-tooltip',
        'tooltip-placement',
        'icon-class',
        'manage',
        'unstyled'
    ],

    data: () => ({
        loading: false,
        following: false,
        showAuthModal: false,
        showListingModal: false
    }),

    created() {
        const user = this.user;
        if (!user) {
            return;
        }

        var productIds = this.app.user_products;
        const productId = this.product.id;

        this.following = productIds.includes(productId);

        Echo.private('users.' + user.id)
            .listen(".product.user_subscribed", e => {
                if (e.product.id === this.product.id) {
                    this.following = true;
                }
            })
            .listen(".product.user_unsubscribed", e => {
                if (e.product.id === this.product.id) {
                    this.following = false;
                }
            });
    },

    mounted() {},

    computed: {
        tooltipOptions() {
            var options = {};

            if (this.following) {
                options.content = this.unsubscribeTooltip;
            } else {
                options.content = this.subscribeTooltip;
            }

            if (this.tooltipPlacement) {
                options.placement = this.tooltipPlacement;
            }

            return options;
        },

        defaultButtonClass() {
            return 'btn btn-light border-2 rounded-full font-semibold';
        },

        followButtonClass() {
            if (this.unstyled) {
                return '';
            }

            return this.btnClass + ' btn-follow '  + this.defaultButtonClass;
        },

        unfollowButtonClass() {
            if (this.unstyled) {
                return '';
            }

            return this.btnClass + ' btn-unfollow ' + this.defaultButtonClass;
        },

        subscribeSlotPassed() {
            return !!this.$slots.subscribe?.[0];
            // return !!this.$slots.subscribe?.[0].text.length;
        },

        unsubscribeSlotPassed() {
            return !!this.$slots.unsubscribe?.[0];
            // return !!this.$slots.unsubscribe?.[0].text.length;
        }
    },

    methods: {
        showListingsModal() {
            this.showListingModal = true;
        },

        onUserAuth() {
            //
        },

        onAuthModalClosed() {
            this.showAuthModal = false;
        },

        onListingModalClosed() {
            this.showListingModal = false;
        },

        onButtonClick($event) {
            $event.preventDefault();
            $event.stopPropagation();
        },

        onClickFollow($event) {
            $event.preventDefault();
            $event.stopPropagation();

            const productId = this.product.id;

            if (!this.user) {
                this.showAuthModal = true;
                // window.location.href = '/products/' + productId + '/subscribe';
                return;
            }

            this.followProduct(productId);
        },

        onClickUnfollow($event) {
            $event.preventDefault();
            $event.stopPropagation();

            const productId = this.product.id;

            if (!this.user) {
                this.showAuthModal = true;
                // window.location.href = '/products/' + productId + '/unsubscribe';
                return;
            }

            this.unfollowProduct(productId);
        },

        followProduct(productId) {
            this.loading = true;

            axios.post(`/api/products/${productId}/subscribe`)
                .then(response => {
                    // @todo trigger analytics event (product_subscribe)

                    this.following = true;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        },

        unfollowProduct(productId) {
            this.loading = true;

            axios.delete(`/api/products/${productId}/subscribe`)
                .then(response => {
                    // @todo trigger analytics event (product_unsubscribe)

                    this.following = false;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
